import React, { useContext, useState } from 'react';
import Select from 'react-select';
import styled from 'styled-components';
import {
  FILTER_COLOR_OPTIONS,
  FILTER_MAX_GARMENTS_COUNT,
  FILTER_MIN_GARMENTS_COUNT,
  MIN_PC_S_BODY_WIDTH,
  MIN_TABLET_BODY_WIDTH,
} from '../../../constants/StylistConstants';
import { FiltersContext } from '../../../context/FiltersContext';
import { FiltersContextType } from '../../../context/types/FiltersContextType';
import { Range, getTrackBackground } from 'react-range';
import { TextLabel, TextRegular } from '../../Text';
import { BaseButton } from '../../Button';

const STEP = 1;

const Filters = () => {
  const {
    saveShowFilters,
    filterColors,
    filterGarmentsCount,
    saveFilterColors,
    saveGarmentsCount,
  } = useContext(FiltersContext) as FiltersContextType;
  const [garmentsCount, setGarmentsCount] = useState(filterGarmentsCount);
  const [selectedColors, setSelectedColors] = useState(filterColors);

  const applyFilters = () => {
    saveFilterColors(selectedColors);
    saveGarmentsCount(garmentsCount);
    saveShowFilters(false);
  };
  const resetFilters = () => {
    saveFilterColors([]);
    saveGarmentsCount([FILTER_MIN_GARMENTS_COUNT, FILTER_MAX_GARMENTS_COUNT]);
    saveShowFilters(false);
  };

  return (
    <Container>
      <Wrapper>
        <TextLabel fontWeight={300}>
          the number of things in the image
        </TextLabel>
        <CountFilter>
          <Range
            values={garmentsCount}
            step={STEP}
            min={FILTER_MIN_GARMENTS_COUNT}
            max={FILTER_MAX_GARMENTS_COUNT}
            onChange={(values) => {
              setGarmentsCount(values);
            }}
            renderMark={({ props, index }) => (
              <div
                {...props}
                style={{
                  ...props.style,
                  position: 'absolute',
                  paddingTop: '50px',
                  color:
                    index + FILTER_MIN_GARMENTS_COUNT < garmentsCount[0] ||
                    index + FILTER_MIN_GARMENTS_COUNT > garmentsCount[1]
                      ? '#f3f3f3'
                      : 'black',
                  fontWeight: '700',
                  fontSize: '16px',
                  lineHeight: '24px',
                  fontFamily: 'Poppins',
                }}
              >
                {index + FILTER_MIN_GARMENTS_COUNT}
              </div>
            )}
            renderTrack={({ props, children }) => (
              <div
                onMouseDown={props.onMouseDown}
                onTouchStart={props.onTouchStart}
                style={{
                  ...props.style,
                  height: '36px',
                  display: 'flex',
                  width: '100%',
                }}
              >
                <div
                  ref={props.ref}
                  style={{
                    height: '2px',
                    width: '100%',
                    background: getTrackBackground({
                      values: garmentsCount,
                      colors: ['#f3f3f3', 'black', '#f3f3f3'],
                      min: FILTER_MIN_GARMENTS_COUNT,
                      max: FILTER_MAX_GARMENTS_COUNT,
                    }),
                    alignSelf: 'center',
                  }}
                >
                  {children}
                </div>
              </div>
            )}
            renderThumb={({ index, props, isDragged }) => (
              <div
                {...props}
                style={{
                  ...props.style,
                  height: '20px',
                  width: '20px',
                  borderRadius: '10px',
                  backgroundColor: 'black',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  boxShadow: '0px 2px 6px #AAA',
                }}
              ></div>
            )}
          />
        </CountFilter>
        <TextLabel fontWeight={300}>choose color</TextLabel>
        <ColorFilter>
          <TextRegular fontWeight={300}>
            <Select
              styles={{
                control: (provided) => ({
                  ...provided,
                  borderRadius: '0',
                  borderColor: 'black',
                  boxShadow: 'none',
                  '&:hover': {
                    borderColor: 'black',
                  },
                }),
              }}
              onChange={(selectedOption) => {
                setSelectedColors(selectedOption.map((val) => val));
              }}
              options={FILTER_COLOR_OPTIONS}
              defaultValue={selectedColors}
              isMulti={true}
              isClearable={true}
              isSearchable={true}
            ></Select>
          </TextRegular>
        </ColorFilter>
      </Wrapper>
      <Buttons>
        <BaseButton
          style={{
            width: '50%',
            border: 'none',
            backgroundColor: '#ffffff',
            color: '#000000',
          }}
          onClick={() => {
            resetFilters();
          }}
        >
          reset
        </BaseButton>
        <BaseButton
          style={{ width: '50%', border: 'none' }}
          onClick={() => {
            applyFilters();
          }}
        >
          apply
        </BaseButton>
      </Buttons>
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  padding-bottom: 120px;

  @media (max-width: ${MIN_PC_S_BODY_WIDTH - 1}px) {
    padding-bottom: 90px;
  }
`;

const Wrapper = styled.div`
  width: 85%;
  margin: auto;
`;

const ColorFilter = styled.div`
  padding-top: 25px;

  @media (max-width: ${MIN_PC_S_BODY_WIDTH - 1}px) {
    padding-top: 15px;
  }
`;

const CountFilter = styled.div`
  padding-top: 25px;
  padding-bottom: 50px;
  width: 95%;
  margin: auto;

  @media (max-width: ${MIN_PC_S_BODY_WIDTH - 1}px) {
    padding-top: 0;
    padding-bottom: 40px;
  }
`;

const Buttons = styled.div`
  cursor: pointer;
  width: 100%;
  border-top: 1px solid black;
  height: 64px;
  position: absolute;
  display: flex;
  bottom: 0;

  @media (max-width: ${MIN_TABLET_BODY_WIDTH - 1}px) {
    height: 45px;
  }
`;

export default Filters;
